var $e367003b4ef79d54$exports = {};
"use strict";
//Hämtar varukorg från localStorage och element som ska visa beställningar.
document.addEventListener('DOMContentLoaded', ()=>{
    let cart = JSON.parse(localStorage.getItem('cart')) || [];
    const orderList = document.getElementById('orderList');
    function renderCart() {
        orderList.innerHTML = '';
        if (cart.length === 0) {
            orderList.innerHTML = "<p>Varukorgen \xe4r tom.</p>";
            return;
        }
        //Loopar igenom och bygger HTML med namn, antal, +/- knappar, pris, totalpris och ta bort-knapp
        cart.forEach((item)=>{
            const div = document.createElement('div');
            div.classList.add('orderItem');
            div.dataset.id = item._id;
            div.innerHTML = `
                <p><strong>${item.name}</strong><p>
                <p>
                    Antal:
                    <button class="decreaseBtn">\u{2013}</button>
                    <span class="quantity">${item.quantity}</span>
                    <button class="increaseBtn">+</button>
                </p>
                <p>Total: <span class="itemTotal">${item.price * item.quantity}</span> kr</p>
                <button class="removeBtn">TA BORT</button>
            `;
            orderList.appendChild(div);
        });
        updateTotal();
    }
    //Räknar ut totalbelopp och skriver ut det på skärmen.
    function updateTotal() {
        const total = cart.reduce((sum, item)=>sum + item.price * item.quantity, 0);
        let totalDiv = document.getElementById('totalDiv');
        if (!totalDiv) {
            totalDiv = document.createElement('div');
            totalDiv.id = 'totalDiv';
            orderList.appendChild(totalDiv);
        }
        totalDiv.innerHTML = `<p><strong>Totalt att betala: ${total} kr</strong></p>`;
    }
    //Uppdaterar skärmen med antal och totalsumma vid ändringar.
    function updateOrderDisplay(orderItemDiv, item) {
        orderItemDiv.querySelector('.quantity').textContent = item.quantity;
        orderItemDiv.querySelector('.itemTotal').textContent = item.price * item.quantity;
    }
    //Lyssnar på klick på hela orderList.
    orderList.addEventListener('click', (e)=>{
        const target = e.target;
        const orderItemDiv = target.closest('.orderItem');
        if (!orderItemDiv) return;
        const id = orderItemDiv.dataset.id;
        const itemIndex = cart.findIndex((item)=>item._id === id);
        if (itemIndex === -1) return;
        //Om användar klickar på + ökar antalet, vid - minskar antalet, vid 0 tas varan bort.
        if (target.classList.contains('increaseBtn')) {
            cart[itemIndex].quantity++;
            updateOrderDisplay(orderItemDiv, cart[itemIndex]);
        } else if (target.classList.contains('decreaseBtn')) {
            if (cart[itemIndex].quantity > 1) {
                cart[itemIndex].quantity--;
                updateOrderDisplay(orderItemDiv, cart[itemIndex]);
            } else {
                cart.splice(itemIndex, 1);
                orderItemDiv.remove();
            }
        } else if (target.classList.contains('removeBtn')) {
            cart.splice(itemIndex, 1);
            orderItemDiv.remove();
        } else return; //Om annat element klickades, gör inget
        //Spara ändringar i localStorage
        localStorage.setItem('cart', JSON.stringify(cart));
        updateTotal();
        //Om varukorgen är tom, visa meddelande
        if (cart.length === 0) orderList.innerHTML = "<p>Varukorgen \xe4r tom.</p>";
    });
    renderCart();
});
//Hämta formulär-element samt element för meddelanden.
const $e367003b4ef79d54$var$form = document.getElementById("orderForm");
const $e367003b4ef79d54$var$messageEl = document.getElementById("message");
//Addera händelselyssnare på formulär
$e367003b4ef79d54$var$form.addEventListener("submit", async (e)=>{
    e.preventDefault();
    //Rensa tidigare meddelande samt klass
    $e367003b4ef79d54$var$messageEl.textContent = "";
    $e367003b4ef79d54$var$messageEl.className = "";
    //Hämta värden från formuläret
    const customerName = document.getElementById("name").value.trim();
    const phoneNumber = document.getElementById("number").value.trim();
    const street = document.getElementById("street").value.trim();
    const postalCode = document.getElementById("postalcode").value.trim();
    const city = document.getElementById("city").value.trim();
    const paymentMethod = document.querySelector('input[name="payment"]:checked').value;
    //Kontrollera obligatoriska fält
    if (!customerName || !phoneNumber || !street || !postalCode || !city) {
        $e367003b4ef79d54$var$messageEl.textContent = "Alla f\xe4lt m\xe5ste fyllas i.";
        $e367003b4ef79d54$var$messageEl.className = "error-message";
        return;
    }
    //Hämta varukorg från localStorage
    const cart = JSON.parse(localStorage.getItem("cart")) || [];
    //Kontrollera att varukogen inte är tom.
    if (cart.length === 0) {
        $e367003b4ef79d54$var$messageEl.textContent = "Varukorgen \xe4r tom. Du m\xe5ste l\xe4gga till minst en vara.";
        $e367003b4ef79d54$var$messageEl.className = "error-message";
        return;
    }
    //Kontrollera telefonnummer
    const phoneRegex = /^[0-9+\-\s]{7,15}$/;
    if (!phoneRegex.test(phoneNumber)) {
        $e367003b4ef79d54$var$messageEl.textContent = "Telefonnumret \xe4r inte korrekt ifyllt.";
        $e367003b4ef79d54$var$messageEl.className = "error-message";
        return;
    }
    //Kontrollera postkod
    const postalRegex = /^[0-9]{5}$/;
    if (!postalRegex.test(postalCode)) {
        $e367003b4ef79d54$var$messageEl.textContent = "Postnumret \xe4r inte korrekt ifyllt.";
        $e367003b4ef79d54$var$messageEl.className = "error-message";
        return;
    }
    //Bygg items-array enligt schemastruktur för beställningar.
    const items = cart.map((item)=>({
            menuItem: item._id,
            quantity: item.quantity
        }));
    //Räkna ut totalpris
    const totalPrice = cart.reduce((sum, item)=>sum + item.price * item.quantity, 0);
    //Bygg orderobjekt
    const newOrder = {
        customerName: customerName,
        phoneNumber: phoneNumber,
        address: {
            street: street,
            postalCode: postalCode,
            city: city
        },
        items: items,
        totalPrice: totalPrice
    };
    try {
        const response = await fetch("https://dt207g-project-restapi.onrender.com/api/order", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(newOrder)
        });
        if (!response.ok) throw new Error("Kunde inte skicka best\xe4llningen.");
        //Töm formulär och varukorg
        $e367003b4ef79d54$var$form.reset();
        localStorage.removeItem("cart");
        document.getElementById("orderList").innerHTML = "<p>Varukorgen \xe4r tom.</p>";
        //Visa bekräftelse
        $e367003b4ef79d54$var$messageEl.textContent = "Din best\xe4llning \xe4r mottagen och \xe4r snart p\xe5 v\xe4g till dig! \u2705";
        //Dölj tillbaka-pilen om den finns
        const backArrow = document.querySelector(".backToMenu");
        if (backArrow) backArrow.style.display = "none";
        //Skapa tillbaka-knapp
        const backButton = document.createElement("button");
        backButton.textContent = "G\xc5 TILL MENY";
        backButton.className = "backBtn";
        backButton.addEventListener("click", ()=>{
            window.location.href = "index.html";
        });
        $e367003b4ef79d54$var$messageEl.appendChild(document.createElement("br"));
        $e367003b4ef79d54$var$messageEl.appendChild(backButton);
    } catch (err) {
        console.error("Fel vid best\xe4llning:", err);
        $e367003b4ef79d54$var$messageEl.textContent = "Ett fel uppstod vid best\xe4llningen. F\xf6rs\xf6k igen.";
        $e367003b4ef79d54$var$messageEl.className = "error-message";
    }
});


//# sourceMappingURL=order.ce6a2a80.js.map
